/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

// SEL and SUL are stored as decimals (e.g. 0.03 = 3%).
const CSS_COLORS = {
  green: '#43a047',
  yellow: '#d4e157',
  orange: '#fb8c00',
  red: '#e53935',
  darkRed: '#b71c1c',
  noData: '#9e9e9e',
};

export const getMarkerCssColor = value => {
  if (value == null) return CSS_COLORS.noData;
  if (value < 0.05) return CSS_COLORS.green;
  if (value < 0.1) return CSS_COLORS.yellow;
  if (value < 0.2) return CSS_COLORS.orange;
  if (value < 0.4) return CSS_COLORS.red;
  return CSS_COLORS.darkRed;
};

const makeSvgIconUrl = fillColor => {
  const svg = [
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 36" width="24" height="36">',
    `<path fill="${fillColor}" stroke="rgba(0,0,0,0.25)" stroke-width="1" d="M12 1C6.48 1 2 5.48 2 11c0 7.5 10 23 10 23S22 18.5 22 11c0-5.52-4.48-10-10-10z"/>`,
    '<circle fill="white" cx="12" cy="11" r="4"/>',
    '</svg>',
  ].join('');
  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
};

const iconCache = {};

const getMarkerIcon = value => {
  const color = getMarkerCssColor(value);
  if (!iconCache[color]) {
    iconCache[color] = makeSvgIconUrl(color);
  }
  return iconCache[color];
};

export default getMarkerIcon;
